export function formatFullName(first: string | undefined | null, last: string | undefined | null): string | undefined {
  return first && last ? `${first} ${last}` : first || last || '';
}
